import { writable } from "svelte/store";

/**
 * A store that keeps track of whether to hide header even if it's supposed to be shown.
 */
export const hideHeaderStore = writable(false);
